import { render } from "./control.vue?vue&type=template&id=1a5aed08&ts=true"
import script from "./control.vue?vue&type=script&setup=true&lang=ts"
export * from "./control.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/spug/spug_api/repos/119_10566_20260928180206/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/space-division/control.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a5aed08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a5aed08', __exports__)) {
    console.log('reload')
    api.reload('1a5aed08', __exports__)
  }
  
  module.hot.accept("./control.vue?vue&type=template&id=1a5aed08&ts=true", () => {
    console.log('re-render')
    api.rerender('1a5aed08', render)
  })

}


export default __exports__